import { RestApiService, StorefrontApiService } from './api';
import { graphqlClient } from './graphql';

// You can export here services, ES module exports ensure these will all be a single object
export const storefrontApiService = new StorefrontApiService({ api: graphqlClient });
export const restApiService = new RestApiService();

export * from './analytics';
